import { ChevronRight } from "@mui/icons-material";
import { Box, Button, Typography, alpha, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { CannabisIcon } from "@/components/icons/CannabisIcon";

/** Atalho mobile do dashboard para a tela dedicada de documentos. */
export function PatientSupportingDocumentsDashButton() {
  const theme = useTheme();
  const navigate = useNavigate();
  const accent = theme.palette.primary800.main;

  return (
    <Button
      fullWidth
      variant="contained"
      onClick={() => navigate("/patient-documents")}
      sx={{
        width: "100%",
        borderRadius: 99,
        py: 1.05,
        px: 1.5,
        minHeight: 44,
        textTransform: "none",
        fontWeight: 700,
        fontSize: "0.8125rem",
        bgcolor: "primary800.main",
        color: "neutral0.main",
        boxShadow: `0 4px 12px ${alpha(accent, 0.22)}`,
        "&:hover": { bgcolor: "primary900.main" },
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <CannabisIcon sx={{ fontSize: 20, flexShrink: 0 }} />
        <Typography
          component="span"
          variant="body2"
          fontWeight={700}
          sx={{ flex: 1, minWidth: 0, textAlign: "left", fontSize: "0.8125rem" }}
        >
          Tratamento canabinoide
        </Typography>
        <ChevronRight sx={{ fontSize: 20, flexShrink: 0, opacity: 0.9 }} />
      </Box>
    </Button>
  );
}
